export default __webpack_public_path__ + "static/media/Sharp Pommelin.38f4d30a.png";